import React, { useEffect, useState } from 'react';
import classnames from 'classnames';

// Icons
import Close from 'svg/close';
import EffectOne from 'svg/effect1';
import EffectTwo from 'svg/effect2';
import EffectThree from 'svg/effect3';

/**
 * The Visualizer
 *
 * Draws stuff to screen based on beats.
 * Currently this is some star kind of shapes.
 */
const Visualizer = (props) => {
  // state
  const [filterActive, setFilterActive] = useState(false);
  const [reverbActive, setReverbActive] = useState(false);
  const [delayActive, setDelayActive] = useState(false);

  /**
   * Toggle the master effect
   * @param  {string} effectType [the effect to toggle]
   */
  const toggleEffect = (effectType) => {
    const effects = ['filter', 'reverb', 'delay'];
    const id = effects.indexOf(effectType);
    props.controller.toggleMasterEffect(id);
  }

  useEffect(() => {
    setFilterActive(props.controller.getMasterEffect(0));
    setReverbActive(props.controller.getMasterEffect(1));
    setDelayActive(props.controller.getMasterEffect(2));
    // eslint-disable-next-line
  }, []);

  return (
    <article className='Main-overlay Visualizer'>
      {/*Actions to control the visualizer*/}
      <button
        title='Close'
        className='button button--outline button__close'
        onClick={props.closeAction}
      >
        <Close className='Visualizer__icon Visualizer__icon-close' title='Close' />
      </button>
      <ul className='Visualizer__list'>
        <li className='Visualizer__list-item'>
          <button
            title='Effect One'
            className={classnames('button button--outline Visualizer__list-button', {
              active: filterActive
            })}
            onClick={() => {
              setFilterActive(!filterActive);
              toggleEffect('filter');
            }}
          >
            <EffectOne className='Visualizer__icon Visualizer__icon-effect-one' title='Filter' />
          </button>
        </li>
        <li className='Visualizer__list-item'>
          <button
            title='Effect Two'
            className={classnames('button button--outline Visualizer__list-button', {
              active: reverbActive
            })}
            onClick={() => {
              setReverbActive(!reverbActive);
              toggleEffect('reverb');
            }}
          >
            <EffectTwo className='Visualizer__icon Visualizer__icon-effect-two' title='Reverb' />
          </button>
        </li>
        <li className='Visualizer__list-item'>
          <button
            title='Effect Three'
            className={classnames('button button--outline Visualizer__list-button', {
              active: delayActive
            })}
            onClick={() => {
              setDelayActive(!delayActive);
              toggleEffect('delay');
            }}
          >
            <EffectThree className='Visualizer__icon Visualizer__icon-effect-three' title='Delay' />
          </button>
        </li>
      </ul>
    </article>
  );
};

export default Visualizer;

